import React from 'react';
import { Placeholder } from 'rsuite';

const RedditDashboardPieChartLoader = () => (
	<div className="flex items-center h-full w-full gap-[12px]">
		<Placeholder.Graph
			active
			className="!w-[56px] !min-w-[56px] !h-[56px] !rounded-full"
		/>

		<div className="flex flex-col gap-[4px] w-full items-center justify-center">
			<Placeholder.Graph
				active
				className="!h-[12px] !rounded-[8px]"
			/>

			<Placeholder.Graph
				active
				className="!h-[12px] !rounded-[8px]"
			/>

			<Placeholder.Graph
				active
				className="!h-[12px] !rounded-[8px]"
			/>

			<Placeholder.Graph
				active
				className="!h-[12px] !rounded-[8px]"
			/>
		</div>
	</div>
);

export default RedditDashboardPieChartLoader;
